import React from "react";
import { useAppSelector } from "../../store/hooks";
import { selectPermissions } from "../../store/slices/authSlice";

const AccessDenied: React.FC = () => {
  const permissions = useAppSelector(selectPermissions);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #e3e7ed 100%)",
        borderRadius: "16px",
        boxShadow: "0 4px 24px rgba(44,62,80,0.10)",
        margin: "40px auto",
        maxWidth: "420px",
        padding: "48px 32px",
        border: "1px solid #e0e0e0",
      }}
    >
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginBottom: "24px" }}
      >
        <circle cx="32" cy="32" r="32" fill="#ffeaea" />
        <path d="M20 44L44 20M44 44L20 20" stroke="#d32f2f" strokeWidth="4" strokeLinecap="round" />
      </svg>
      <h1 style={{ color: "#d32f2f", marginBottom: "12px", fontSize: "2rem", fontWeight: 700 }}>
        Access Denied
      </h1>
      <p style={{ color: "#555", fontSize: "1.15rem", marginBottom: "20px", textAlign: "center" }}>
        {permissions.length === 0
          ? "You do not have permission to view any of the sections."
          : "You do not have permission to view this section."}
      </p>
    </div>
  );
};

export default AccessDenied;
